import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'

import { UNIFIED_APP_LINK } from '@shared/contants'
import { APPS } from '@shared/contants/app'
import QrCode from '@shared/ui/qrcode'

import styles from './styles.module.scss'

export default function BannerApp () {
  const { t: tb } = useTranslation('appBanner')

  // Get App Store and Google Play links
  const appStoreApp = APPS.find((app) => app.icon.includes('apple'))
  const googlePlayApp = APPS.find((app) => app.icon.includes('play-market'))

  return (
    <div className={styles.root}>
      <div className={styles.root__left}>
        <div className={styles.root__content}>
          <h2 className={styles.root__title}>{tb('title')}</h2>
          <p className={styles.root__desc}>{tb('desc')}</p>
          <div className={styles.root__buttons}>
            {appStoreApp && (
              <Link
                to={appStoreApp.href}
                target="_blank"
                className={styles.root__button}
              >
                <div className={styles.root__buttonIcon}>
                  <img src={appStoreApp.icon} alt="" />
                </div>
                <div className={styles.root__buttonText}>
                  <span className={styles.root__buttonLabel}>
                    {tb('appStore.label')}
                  </span>
                  <span className={styles.root__buttonName}>
                    {tb('appStore.name')}
                  </span>
                </div>
              </Link>
            )}
            {googlePlayApp && (
              <Link
                to={googlePlayApp.href}
                target="_blank"
                className={styles.root__button}
              >
                <div className={styles.root__buttonIcon}>
                  <img src={googlePlayApp.icon} alt="" />
                </div>
                <div className={styles.root__buttonText}>
                  <span className={styles.root__buttonLabel}>
                    {tb('googlePlay.label')}
                  </span>
                  <span className={styles.root__buttonName}>
                    {tb('googlePlay.name')}
                  </span>
                </div>
              </Link>
            )}
          </div>
        </div>
      </div>
      <div className={styles.root__right}>
        <div className={styles.root__qrWrapper}>
          <QrCode
            value={UNIFIED_APP_LINK}
            size={165}
            className={styles.root__qrCode}
          />
        </div>
      </div>
    </div>
  )
}
